<template>
  <div class="login-page-container" id="banner">
    <div class="login-form-container" v-if="gameList">
      <jt-login-form
        class="login-form"
        :gameList="gameList"
        :zhuti="zhuti"
        :tips="tips"
        :nickname="nickname"
        :username="username"
        :checking="checking"
        @login="userLogin"
        @wxbase="wxbase"
        :loginloading="loginloading"
        :isButtonList="isButtonList"
        :isButtonNotBg="isButtonNotBg"
        :weihu="weihu"
        :curindex="curindex"
        @resetindex="resetindex"
        :style="{ backgroundColor: bgcolor }"
      ></jt-login-form>
    </div>
  </div>
</template>

<script>
import jtLoginForm from './jtLoginForm'
import GameModel from '../../models/game'
import UserModel from '../../models/user'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'
import { Base64 } from 'js-base64'
import { tip } from '@/utils/tool'

export default {
  name: 'Login',
  components: {
    jtLoginForm,
  },
  data() {
    return {
      gameList: null,
      domainName: '',
      zhuti: '',
      tips: '',
      nickname: '',
      username: '',
      checking: true,
      loginloading: false,
      isButtonNotBg: false,
      isButtonList: false,
      curindex: -1,
      bgcolor: 'rgba(255,255,255)',
    }
  },
  methods: {
    async userLogin(userInfo) {
      const info = storage.getItem(constants.WX_INFO)
      if (this.username) {
        this.wxLogin(userInfo.gameId)
      } else {
        const value = _.trim(userInfo.val)
        if (!_.isEmpty(value)) {
          let data = await UserModel.wxRegister(
            userInfo.gameId,
            info.oid,
            value
          )
          if (data.errNo === 0) {
            let con = '你已成功绑定，将不得再更改!'
            con = this.tips ? this.tips : con
            this.$alert(con, '温馨提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              callback: (action) => {
                this.wxLogin(userInfo.gameId)
              },
            })
          } else {
            tip(this.zhuti + '已存在')
          }
        } else {
          tip('请填写' + this.zhuti)
        }
      }
    },

    async wxLogin(gameId) {
      const info = storage.getItem(constants.WX_INFO)
      const that = this
      let loginInfo = await UserModel.wxLogin(gameId, info.oid, that)
      if (loginInfo) {
        const router = this.$router
        storage.setItem(constants.GLOBAL_CONFIG, loginInfo)
        router.push(`/page/${loginInfo.pageInfo[0].pageId}`)
      }
    },

    async wxbase(id) {
      this.checking = false
      const info = storage.getItem(constants.WX_INFO)
      if (id == null) {
        this.$message.error(this.$t('jtRegisterPage.GAME_ID_IS_NULL'))
      } else {
        const data = await UserModel.registercheck(id)
        if (data.errNo === 0) {
          let zhuti = data.payload ? data.payload['注册主体'] : '姓名'
          let tips = data.payload ? data.payload['注册提示'] : ''

          const data1 = await UserModel.wxUserCheck(id, info.oid)
          let username = null
          if (data1.errNo === 0) {
            username = data1.payload
          }
          this.zhuti = zhuti
          this.tips = tips
          this.nickname = Base64.decode(info.nickname)
          this.username = username
          this.checking = true
        } else {
          this.$message.error(data.errMsg)
        }
      }
    },

    resetindex() {
      this.curindex = -1
    },
  },
  async mounted() {
    // this.gameList = obj.gamelist
    // this.$root.DOMAINNAME = obj.domainName
    // let logo = obj.logo ? obj.logo : 1
    // storage.setItem(constants.LOGO, logo)
    // storage.setItem(constants.GAME_LIST, this.gameList)
    // const languageConfig = storage.getItem(constants.LANGUAGE)
    // if (languageConfig) {
    //   const lang = {
    //     中文: 'zh',
    //     英文: 'en',
    //   }
    //   const language = languageConfig
    //   this.$i18n.locale = lang[language]
    //   this.$i18n.fallbackLocale = lang[language]
    // } else {
    //   this.$i18n.locale = process.env.VUE_APP_I18N_LOCALE || 'zh'
    //   this.$i18n.fallbackLocale = process.env.VUE_APP_I18N_LOCALE || 'zh'
    // }

    let obj = await GameModel.getGameList(true)
    this.gameList = obj.gamelist
    this.isButtonList = obj.isButtonList
    this.isButtonNotBg = obj.isButtonNotBg
    this.bgcolor = obj.bgcolor
    this.weihu = obj.weihu
    this.$root.DOMAINNAME = obj.domainName
    this.$root.VISIBLE = obj.visible
    this.$root.HEADLOGO = obj.headlogo
    storage.setItem('bannerUrl', obj.bannerUrl)

    this.$emit('isShowHeader')

    if (obj.bannerUrl) {
      if (document.getElementById('banner')) {
        document.getElementById('banner').classList.add('banner')
      }
    }

    let logo = obj.logo ? obj.logo : 1

    storage.setItem(constants.LOGO, logo)
    storage.setItem(constants.GAME_LIST, this.gameList)
  },
}
</script>

<style lang="stylus" scoped>
.login-page-container {
  height: 100%;

  div.bread-crumb {
    padding: 1em;
  }

  .login-form-container {
    min-height: calc(100% - 3em);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-form {
    width: 50%;
  }
}

.banner {
  .login-form-container {
    min-height: calc(100% - 46px);
  }

  .login-form {
    // background-color: rgba(255, 255, 255, 0.5);
    border: none;
    color: #000;
  }
}

@media screen and (max-width: 768px) {
  .login-page-container {
    .login-form {
      width: 90%;
    }
  }
}
</style>
